"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PostCard = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _faded = require("@mui-treasury/styles/shadow/faded");

var _slope = require("@mui-treasury/styles/cardMedia/slope");

var _n = require("@mui-treasury/styles/textInfoContent/n01");

var _customComponents = require("../../../../utils/customComponents");

var _TextInfo = _interopRequireDefault(require("../../../../components/PageGrid/atoms/TextInfo/TextInfo"));

var _CardMedia = _interopRequireDefault(require("../../../../components/PageGrid/atoms/CardMedia/CardMedia"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CardActions = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/CardActions/CardActions"));
  });
});
/* istanbul ignore next */

var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/atoms/Icon/Icon"));
  });
});
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      maxWidth: 304,
      margin: 'auto'
    },
    content: {
      padding: 24
    },
    avatar: {
      width: 50,
      height: 50,
      border: '2px solid #fff',
      margin: '-48px 32px 0 auto',
      '& > img': {
        margin: 0
      }
    }
  };
});

var PostCard = /*#__PURE__*/_react.default.memo(function (_ref) {
  var image = _ref.image,
      overline = _ref.overline,
      heading = _ref.heading,
      body = _ref.body,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass,
      cardActions = _ref.cardActions,
      icon = _ref.icon,
      imgAlt = _ref.imgAlt,
      imgTitle = _ref.imgTitle;
  var cardStyles = useStyles();
  var mediaStyles = (0, _slope.useSlopeCardMediaStyles)();
  var shadowStyles = (0, _faded.useFadedShadowStyles)();
  var textCardContentStyles = (0, _n.useN01TextInfoContentStyles)();
  var actions = cardActions[0];
  var avatar = icon[0];
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: (0, _clsx.default)(cardStyles.root, shadowStyles.root, storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_CardMedia.default, {
    image: image,
    classes: mediaStyles,
    alt: imgAlt,
    title: imgTitle
  }), avatar ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    className: cardStyles.avatar
  }, (0, _customComponents.renderComponentsWithBridge)({
    Icon: Icon
  }, _objectSpread(_objectSpread({}, avatar), {}, {
    style: cardStyles.avatar
  })))) : null, /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: cardStyles.content
  }, /*#__PURE__*/_react.default.createElement(_TextInfo.default, {
    classes: textCardContentStyles,
    overline: overline,
    heading: heading,
    body: body
  }), actions ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)({
    CardActions: CardActions
  }, actions)) : null));
});

exports.PostCard = PostCard;
var _default = PostCard;
exports.default = _default;
PostCard.propTypes = {
  /** actions to add in card */
  icon: _propTypes.default.arrayOf(_propTypes.default.shape()),

  /** actions to add in card */
  cardActions: _propTypes.default.arrayOf(_propTypes.default.shape()),

  /** overline text */
  overline: _propTypes.default.string.isRequired,

  /** overline heading  */
  heading: _propTypes.default.string.isRequired,

  /** overline body  */
  body: _propTypes.default.string.isRequired,

  /** alt text for the image if url cant display  */
  imgAlt: _propTypes.default.string.isRequired,

  /** the title for the image */
  imgTitle: _propTypes.default.string.isRequired,

  /**
   * url for image
   * Image to be displayed as a background image
   * */
  image: _propTypes.default.string.isRequired,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
PostCard.defaultProps = {
  icon: [],
  cardActions: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};